import styled from 'styled-components'
import { Image as Pic, Option } from 'components'

export const Main = styled.div`
  display: block;
`

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

export const ContainerCard = styled.div`
  width: 100%;
  min-width: 260px;
  max-width: 260px;
  height: 528px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    'image image'
    'name name'
    'info info';

  /*  padding: 16px; */
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(117, 117, 117, 0.2);
  border-radius: 8px;

  :hover {
    transform: scale(1.05);
  }

  @media (max-width: 586px) {
    min-width: 290px;
    max-width: 328px;
  }
`

export const CardInfo = styled.div`
  grid-area: info;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    'month anual'
    'deadlines day'
    'captured goal'
    'bar bar'
    'detail detail';

  padding: 16px;

  gap: 8px 0px;
  position: relative;
  top: 17px;
`

export const Detail = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;

  display: flex;
  align-items: center;

  color: var(--blue);
  cursor: pointer;
`

export const Label = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #757575;
`

export const Image = styled(Pic)`
  height: 227px;
  width: inherit;
  background-size: cover;
  border-radius: 8px 8px 0px 0px;
  background-position: bottom;
`
export const FilterContainer = styled.div`
  display: block;
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    background-color: transparent;
    padding-bottom: 18px;
  }

  @media (max-width: 586px) {
    flex-direction: column-reverse;

    button {
      padding-bottom: 0px;
      align-self: flex-end;
      margin-bottom: 24px;
    }
  }
`

export const Warranty = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 196px;
  right: -64px;
  top: 120px;
  gap: 5px;

  background: white;

  border-radius: 30px 0 0 30px;
  box-shadow: -5px 5px 6px rgba(27, 27, 27, 0.2);
  border-bottom: 2px solid;
  border-left: 2px solid;
  border-top: 2px solid;
  padding: 0px 6px;

  font-size: 12px;
  font-weight: 650;
  color: var(--blue);

  img {
    width: 30px;
  }

  @media (max-width: 586px) {
    right: -94px;
  }
`
export const OptionClose = styled(Option)`
  img {
    width: 25px;
    height: 25px;
  }
`
